module.exports = __webpack_public_path__ + "static/img/MIKE_SANDOVAL.e83bedb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/video-cover/MIKE_SANDOVAL.jpg
// module id = KZWA
// module chunks = 1